jQuery(function() {
  var store_config = {
  	"punchout_only":0,
	"transfer_label":"Transfer Cart",
	"custom_style":".punchout .popover--loggedin {display: none;} body.punchout .additional_checkout_buttons {display:none} .shopify-payment-button {display:none} body.punchout button[name=\"checkout\"] {display: none!important;} body.punchout .mini-cart__button-container .button--view-cart {min-width: 100%;}", 
	"checkout_selector":"button[name=\"checkout\"]", 
	"transfer_selector":"button[name=\"transfer_items\"]", 
//     "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"btn\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
	"transfer_btn_html":"<button type=\"input\" name=\"transfer_items\" class=\"btn cart-recap__checkout button button--primary button--full button--large\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",

//     "return_selector": "header",
//     "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
// 	"return_selector":"ul[class=\"site-nav\"]",
// 	"return_btn_html":"<li type=\"submit\" name=\"close_punchout\" class=\"btn return_btn site-nav\" onClick=\"POSession.cancel();\" >Exit PunchOut<\/li>"
	};

  
//  var ExtParams = {
//    "transfer_label" : store_config.transfer_label,
//    "style" : "",
//    "custom_style" : store_config.custom_style
//  };
 
  POExt = new Po2go_Shopify(store_config);
  POSession = new Po2go(
    {
      'account':'accountkey',
      'punchout_only' : store_config.punchout_only,
      'extension' : POExt
    }
  );
 
  POSession.init();
  POSession.extension.setupPage();
  POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
 
  //Popover loads/is loaded after the page is loaded
  jQuery('#CartPopoverCont').click(function(){
    POSession.extension.setupPage();
  });
  
  jQuery('#CartToggleItemCount').click(function(){
    POSession.extension.setupPage();
  })
  
  
  if (jQuery('.punchout').length){
   jQuery(".header__pencil-banner").append('<ul role="list"><li class="pencil_banner-menu__item"><button onclick="POSession.cancel();" class="nav-bar__link link" data-type="menuitem">Exit PunchOut</button></li>');
   jQuery('button[name="close_punchout"]').remove();
 
  }
 
});